import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import WelcomeWidget from "./WelcomeWidget";
import Widgets from "./Widgets";
import { withTranslation } from "react-i18next";

const DesignerDashboard = (props: any) => {
  return (
    <React.Fragment>
      <BreadCrumb
        title={props.t("Designer Dashboard")}
        pageTitle={props.t("Designer Dashboard")}
      />
      <div className="grid grid-cols-12 gap-x-5">
        <WelcomeWidget />
        <Widgets />
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DesignerDashboard);
